import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
    type: null,
    id: null,
};

const toolbarSlice = createSlice({
    name: 'toolbar',
    initialState,
    reducers: {
        setToolbarView(state, action) {
            return {
                ...state,
                type: action.payload.type,
                id: action.payload.id,
            };
        },
        clearToolbarView() {
            return initialState;
        },
    },
});

export const { setToolbarView, clearToolbarView } = toolbarSlice.actions;
export default toolbarSlice.reducer;
